import React, {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
} from 'react';
import { useInitialState } from './InitialStateContext';
import { AppSpecs, defaultAppSpecValues } from '../experiments/appSpecs';

interface ExperimentsContextValue {
  is<T extends keyof AppSpecs>(key: T, val: AppSpecs[T]): boolean;
}

const ExperimentsContext = createContext<ExperimentsContextValue>({
  is: (key, val) => defaultAppSpecValues[key] === val,
});

export const ExperimentsProvider: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const { appSpecs } = useInitialState();
  const is = useCallback<ExperimentsContextValue['is']>(
    (key, val) => {
      return appSpecs[key] === val;
    },
    [appSpecs],
  );

  return (
    <ExperimentsContext.Provider value={{ is }}>
      {children}
    </ExperimentsContext.Provider>
  );
};

export const useExperiments = () => {
  const context = React.useContext(ExperimentsContext);
  if (!context) {
    throw new Error('useExperiments must be used within a ExperimentsProvider');
  }

  return context;
};
